// extracted by mini-css-extract-plugin
module.exports = {"list":"global-module--list--2IZfC","main":"global-module--main--2HZpX"};